import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ChangeYourCoverge from './components/change-your-coverage/ChangeYourCoverage';
import LifeChangeEventHeader from './components/Header/header';
class EnrollmentLifeEvent extends Component {
  render() {
    return (
      <div className="change-coverage-center">
        <LifeChangeEventHeader />
        <div className="container-offset">
          <div>
            <Row>
              <Col md="12" className="change-coverage-panel">
                <ChangeYourCoverge />
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}

export default EnrollmentLifeEvent;
